// NOTE: Please format dates like YYYY-MM-DD
export const choreoProjectVideos = [
    {
        name: "StuyFlow Choreo Projects #3",
        date: "2018-04-15",
        videoLink: "https://www.youtube.com/embed/1bEaHE27dqs",
    },
    {
        name: "StuyFlow Choreo Projects #2",
        date: "2018-04-15",
        videoLink: "https://www.youtube.com/embed/PvH2ePItLeY",
    },
    {
        name: "StuyFlow Choreo Projects #1",
        date: "2018-04-15",
        videoLink: "https://www.youtube.com/embed/ot82MzWmKig",
    },
    {
        name: "Grab a Hoedy 🍌 | End of Summer Choreo Project 2018",
        date: "2018-07-04",
        videoLink: "https://www.youtube.com/embed/1PRi8duaO_I",
    },
    {
        name: "RISE | End of Summer Choreo Project 2018",
        date: "2018-09-24",
        videoLink: "https://www.youtube.com/embed/ujxjW3jR0jc"
    },
    {
        name: "Pigeon Dance | End of Summer Choreo Project 2018",
        date: "2018-09-24",
        videoLink: "https://www.youtube.com/embed/YRC3z7t4SD0",
    },
    {
        name: "Stat | End of Summer Choreo Project 2018",
        date: "2018-07-03",
        videoLink: "https://www.youtube.com/embed/oqePUGkKPyE",
    },
    {
        name: "Fallen Kingdom | StuyFlow's Quarantine Choreo Project",
        date: "2020-05-01",
        videoLink: "https://www.youtube.com/embed/N8Ybq4trfg4",
    },
    {
        name: "Dear Shiho",
        date: "2019-07-04",
        videoLink: "https://www.youtube.com/embed/YA7-cytPZrk",
    },
    {
        name: "Creeper Aw Man",
        date: "2019-08-19",
        videoLink: "https://www.youtube.com/embed/ssSJx9DenPM",
    },
]
